/**
 * Copyright IBM Corp. 2022, 2026
 */

/**
 * This component is intentionally left as a JSX,
 * in anticipation of a full refactor of case
 * study pages to Materia pages.
 */

'use client'

import className from 'classnames'
import useProductMeta from '@web/product-meta'

function Quote() {
	return (
		<svg
			viewBox="0 0 35 29"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
		>
			<path d="M16.2014 0H8.16255L0 29H10.8834L16.2014 0ZM35 0H26.9611L18.7986 29H29.682L35 0Z" />
		</svg>
	)
}

export function CaseStudyContent({
	brand,
	theme,
	heading,
	blockquote,
	children,
}) {
	const { themeClass } = useProductMeta(brand)
	return (
		<section
			data-theme={theme}
			className={className('case-study-content', theme, themeClass)}
		>
			<div className="g-grid-container">
				<header>
					{heading && <h3 className="g-type-display-3">{heading}</h3>}
					{blockquote && (
						<>
							<span className={`${brand} ${!heading ? 'no-heading' : ''}`}>
								<Quote />
							</span>
							<blockquote className="g-type-display-4">
								{blockquote.quote}
							</blockquote>
							<p className="attribution g-type-label">
								{blockquote.attribution}
							</p>
						</>
					)}
				</header>
				<div className="g-type-long-body">{children}</div>
			</div>
		</section>
	)
}

export default CaseStudyContent
